import { getApiRequest } from 'api';

import { MissedLesson } from './patchMissedLesson';

export const getMissedLesson = (lesson?: number): Promise<MissedLesson[]> => {
    return getApiRequest(`/missed-lesson/`, { params: { lesson } });
};
